import { FeedbackBlock } from "@dbn/omnichannel-design-system-g4p";
import { option } from "fp-ts";
import { useFormatMessage } from "../../intl";
import { usePollingEffect } from "../../useAPI";
import * as api from "../api";
import { RejectionReason } from "../StandardLoanState";

export type OnApplicationRejected = (result: RejectionReason) => void;

type Props = {
  onContinue: () => void;
  onApplicationRejected: OnApplicationRejected;
};

export function CounterOfferSocialInsuranceWaitingScreen(props: Props) {
  const formatMessage = useFormatMessage();

  usePollingEffect(api.getSocialInsuranceResult, {
    intervalMS: 3000,
    shouldPollingContinue: ({ status }) => status === "RETRY",
    onError: () => {},
    onSuccess: ({ status }) => {
      if (status === "REJECTED") {
        props.onApplicationRejected("BonitaRejected");
      } else if (status === "OK") {
        props.onContinue();
      }
    },
  });

  return (
    <FeedbackBlock
      type="loading"
      heading={formatMessage(
        "StandardLoan.SocialInsurance.WaitingScreen.Heading"
      )}
      subheading={option.some(
        formatMessage("StandardLoan.SocialInsurance.WaitingScreen.SubHeading")
      )}
      size="medium"
    />
  );
}
